import { z } from 'zod';

export const posterOptimizedRequestSchema = z.object({
  oldPath: z.string().min(1),
  newPath: z.string().min(1),
});

export type IPosterOptimizedRequest = z.infer<typeof posterOptimizedRequestSchema>;
